import DropdownToggle from "components/dropdown-toggle/DropdownToggle";
import IconButton from "components/icon-button";
import messages from "messages";
import { useCallback, useEffect, useRef, useState } from "react";
import { Dropdown, Popover } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
import OverlayTrigger from "components/overlay-trigger/OverlayTrigger";

const FilterSVG = () => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1C12 1.55228 11.5523 2 11 2H1C0.447715 2 0 1.55228 0 1Z"
      fill="currentColor"
    />
    <path
      d="M2 5C2 4.44772 2.44772 4 3 4H9C9.55229 4 10 4.44772 10 5C10 5.55228 9.55229 6 9 6H3C2.44772 6 2 5.55228 2 5Z"
      fill="currentColor"
    />
    <path
      d="M5 8C4.44772 8 4 8.44771 4 9C4 9.55229 4.44772 10 5 10H7C7.55228 10 8 9.55229 8 9C8 8.44771 7.55228 8 7 8H5Z"
      fill="currentColor"
    />
  </svg>
);

type Props<T = { id: string; value: string }> = {
  options: T[];
  filter?: T;
  onApply: (arg?: T) => void;
};

const FilterButton = ({ options, filter, onApply }: Props) => {
  const [show, setShow] = useState(false);
  const popoverRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const handleClick = useCallback(
    (e) => {
      // click outside listener
      if (
        !popoverRef.current?.contains(e.target) &&
        !buttonRef.current?.contains(e.target)
      ) {
        setShow(false);
      }
    },
    [popoverRef, buttonRef],
  );

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [handleClick]);

  return (
    <OverlayTrigger
      show={show}
      placement={"right"}
      overlay={
        <Popover
          id="filter-button"
          className={styles["filter-button__popover"]}
        >
          <Popover.Content
            className={styles["filter-button__popover-body"]}
            ref={popoverRef}
          >
            <div className={"rg-11 dark"}>{messages.filterBy}</div>
            <DropdownToggle
              iconSize={"1.5em"}
              title={filter?.value}
              className={styles["filter-button__dropdown-button"]}
            >
              <Dropdown.Item
                className={styles["filter-button__dropdown-item"]}
                onClick={() => onApply()}
              >
                {messages.none}
              </Dropdown.Item>

              {Object.values(options).map((el) => (
                <Dropdown.Item
                  key={el.id}
                  className={styles["filter-button__dropdown-item"]}
                  onClick={() => onApply(el)}
                >
                  {el.value}
                </Dropdown.Item>
              ))}
            </DropdownToggle>
          </Popover.Content>
        </Popover>
      }
    >
      <IconButton
        ref={buttonRef}
        onClick={() => {
          setShow(true);
        }}
        className={getClasses(
          "rounded-0",
          styles["filter-button"],
          filter && styles["filter-button--active"],
        )}
      >
        <FilterSVG />
      </IconButton>
    </OverlayTrigger>
  );
};

export default FilterButton;
